import { searchRequestData } from '../../Utility/apiHelper';
import { requestHideLoader, requestShowLoader } from '../Global/action';
import * as actionType from './type';


export const requestGetAllSalesOrders = (queryparams) => async(dispatch)=>{
    dispatch(requestShowLoader())

    try{
        dispatch({
            type: actionType.REQUEST_GET_ALL_SO
        })
            const orderSearchUrl = `${process.env.REACT_APP_BASE_URL}sales-orders`;
            const responsedata = await searchRequestData(queryparams , orderSearchUrl , false)
        dispatch({
            type: actionType.RECEIVED_ALL_SO,
            payload: responsedata?.data
        })

    }
    catch(error){
        
    }
    dispatch(requestHideLoader())


}